import { combineReducers } from 'redux'

import blockedCompaniesReducer from './blockedCompanies'
import desiredRolesReducer from './desiredRoles'
import educationsReducer from './educations'
import employmentPreferencesReducer from './employmentPreferences'
import onlineProfilesReducer from './onlineProfiles'
import profileReducer from './profile'
import profileCompletionReducer from './profileCompletion'
import projectsReducer from './projects'
import topSkillsReducer from './topSkills'
import uiReducer from './ui'
import uploadedFilesReducer from './uploadedFiles'
import workHistoriesReducer from './workHistory'

import roleListReducer from './roleList'
import statusInfoReducer from './statusInfo'

export default {
  profile: combineReducers({
    blockedCompanies: blockedCompaniesReducer,
    desiredRoles: desiredRolesReducer,
    educations: educationsReducer,
    employmentPreferences: employmentPreferencesReducer,
    onlineProfiles: onlineProfilesReducer,
    profile: profileReducer,
    profileCompletion: profileCompletionReducer,
    topSkills: topSkillsReducer,
    projects: projectsReducer,
    ui: uiReducer,
    uploadedFiles: uploadedFilesReducer,
    workHistories: workHistoriesReducer,
  }),

  roleList: roleListReducer,
  statusInfo: statusInfoReducer,
}
